export class SeaportMinDTO {
    id: number;
    name: string;
    locationSearchForSeaImportPreCarriage: boolean = false;
}